import React from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { DropDownStyled } from '@nike/nike-design-system-components';

const getOptionsBetween = (options, start, end) => {
  const startIndex = options.indexOf(start);
  let endIndex = options.indexOf(end);
  if (endIndex > -1 && startIndex > endIndex) endIndex = -1;

  if (endIndex === -1) return [start];
  if (startIndex === -1) return [end];
  return options.filter((option, index) => index >= startIndex && index <= endIndex);
};

const OptionRangeSelect = ({ name, options, value, onChange, error, errorMessage }) => {
  const startValue = value[0] || null;
  const startIndex = startValue ? options.map(({ value }) => value).indexOf(startValue) : -1;
  const endValue = value.length > 1 ? value[value.length - 1] : null;
  const endOptions = options.filter((option, index) => index > startIndex);
  const handleChange = value => onChange(value);

  return (
    <div className='optionRangeSelect' data-name={name}>
      <DropDownStyled
        id={`${name}_start`}
        error={error}
        options={options}
        label='Start Season'
        name={`${name}_start`}
        placeholder='Start Season'
        value={startValue}
        onChange={e =>
          handleChange(
            getOptionsBetween(
              options.map(({ value }) => value),
              e.target.value,
              endValue
            )
          )
        }
      />
      <DropDownStyled
        id={`${name}_end`}
        options={endOptions}
        label='End Season'
        error={error}
        errorMessage={errorMessage}
        name={`${name}_end`}
        placeholder='End Season'
        value={endValue}
        onChange={e =>
          handleChange(
            getOptionsBetween(
              options.map(({ value }) => value),
              startValue,
              e.target.value
            )
          )
        }
        disabled={!startValue}
      />
      {value.length > 0 && <div className='value'>Selected: {value.join(', ')}</div>}
    </div>
  );
};

OptionRangeSelect.defaultProps = {
  error: false,
  errorMessage: '',
  value: []
};

OptionRangeSelect.propTypes = {
  error: bool,
  errorMessage: string,
  name: string.isRequired,
  onChange: func.isRequired,
  options: arrayOf(shape({ label: string.isRequired, value: string.isRequired })).isRequired,
  value: arrayOf(string)
};

export default OptionRangeSelect;
